import { Theme, css } from '@emotion/react';

import { Radius, Spacing, Typography } from 'chatie-design-system';

import { IChatCharacter } from '@model';

const containerCSS = () => css`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.large}px;
  margin-top: ${Spacing.large}px;
`;

const listCSS = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  padding: 0 ${Spacing.medium}px;

  .title {
    ${Typography.h5};
    padding: 10px 0;
    margin-bottom: 10px;
  }
  .chipContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .chip {
    ${Typography.body14};
    padding: 10px ${Spacing.small}px;
    border-radius: ${Radius.medium}px;
    background-color: ${theme.var.gray50};
    line-height: 18.9px;
  }
  .relationship {
    width: 100%;
    padding: ${Spacing.medium}px;
  }
`;

interface CharacterProfileProps {
  character: IChatCharacter;
}

const CharacterProfile = ({ character }: CharacterProfileProps) => {
  const { information, related_profile } = character;

  const list = [
    {
      id: 'profile',
      title: '🔍 프로필',
      value: [information.gender, information.age + '세', information.job],
    },
    {
      id: 'relationship_with_character',
      title: '❤️ 나와의 관계',
      value: [related_profile.information.relationship],
    },
    {
      id: 'personality',
      title: '🌟 성격',
      value: information?.personality?.split(',') || [],
    },
    {
      id: 'appearance',
      title: '👀 외모',
      value: information?.appearance?.split(',') || [],
    },
  ];

  return (
    <div css={containerCSS}>
      {list.map((item, idx) =>
        item.value.length === 1 && item.value[0] === '' ? null : (
          <div css={listCSS} key={`list_${idx}`}>
            <p className="title">{item.title}</p>
            <div className="chipContainer">
              {item.value.map(
                (val, idx) =>
                  val !== '' && (
                    <div
                      key={`${item.id}_${idx}`}
                      className={`chip ${
                        item.id === 'relationship_with_character' &&
                        'relationship'
                      }`}
                    >
                      {val}
                    </div>
                  )
              )}
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default CharacterProfile;
